import { Linkedin } from "lucide-react";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_3bee16da-1518-4ecf-84ec-23daebfe4616/artifacts/lxb7r3r0_Cybertech%20Prefects%20Logo%20New.png";

const FOOTER_LINKS = [
  { label: "Services", href: "#services" },
  { label: "About", href: "#about" },
  { label: "Testimonials", href: "#testimonials" },
  { label: "Contact", href: "#contact" },
];

export default function Footer() {
  return (
    <footer data-testid="footer" className="bg-[#0A0A0B] border-t border-white/5">
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24 pt-20 pb-10">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-16">
          {/* Brand */}
          <div>
            <img
              src={LOGO_URL}
              alt="CyberTech Prefects"
              className="h-14 w-auto mb-4"
            />
            <p className="text-sm text-zinc-500 leading-relaxed max-w-xs">
              Fractional security leadership for modern enterprises. 
              Secure. Comply. Grow.
            </p>
          </div>

          {/* Links */}
          <div>
            <p className="text-sm font-semibold text-white mb-4">Quick Links</p>
            <ul className="space-y-3">
              {FOOTER_LINKS.map((link) => (
                <li key={link.href}>
                  <a
                    href={link.href}
                    className="text-sm text-zinc-500 hover:text-[#B87333] transition-colors"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Connect */}
          <div>
            <p className="text-sm font-semibold text-white mb-4">Connect</p>
            <a
              href="https://linkedin.com"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-linkedin"
              className="inline-flex items-center gap-2 text-sm text-zinc-500 hover:text-[#B87333] transition-colors"
            >
              <Linkedin className="w-4 h-4" />
              LinkedIn
            </a>
            <p className="text-sm text-zinc-600 mt-4">
              Get in touch for a security assessment.
            </p>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="border-t border-white/5 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-xs text-zinc-600">
            &copy; {new Date().getFullYear()} CyberTech Prefects. All rights reserved.
          </p>
          <p className="text-xs text-zinc-700">
            Secure &bull; Comply &bull; Grow
          </p>
        </div>
      </div>
    </footer>
  );
}
